export function formatMialage(mialage: number | null){
    if(mialage === null) { return ''}
    return mialage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}